import {
  type BoundaryEtag, type BoundaryEtagServerModel, type CompleteBoundaryEtag,
} from './etag.types';

export const createEtagFromServerModel = (etagModel: BoundaryEtagServerModel): BoundaryEtag => ({
  lastUpdatedUserId: etagModel.last_updated_user_id,
  lastUpdatedUserName: etagModel.last_updated_user_name,
  timestamp: etagModel.timestamp,
});

export const createCompleteEtagFromServerModel = (etagModel: BoundaryEtagServerModel): CompleteBoundaryEtag | undefined => {
  if (!etagModel.last_updated_user_id || !etagModel.last_updated_user_name || !etagModel.timestamp) {
    return undefined;
  }

  return {
    lastUpdatedUserId: etagModel.last_updated_user_id,
    lastUpdatedUserName: etagModel.last_updated_user_name,
    timestamp: etagModel.timestamp,
  };
};

export const createEtagServerModel = (etag: BoundaryEtag): BoundaryEtagServerModel => ({
  last_updated_user_id: etag.lastUpdatedUserId,
  last_updated_user_name: etag.lastUpdatedUserName,
  timestamp: etag.timestamp,
});
